module.exports = __webpack_public_path__ + "img/map-marker-start.f9cd2f4d.svg";